RivalIQ.apps.Site.module('controllers', function (controllers, App, Backbone, Marionette, $, _) {

    'use strict';

    const Controller = controllers.Controller = Marionette.Controller.extend({
        start: function (options) {

            const me = this;

            App.commands.setHandler('contact:show', me.onContactShowCommand, me);

            me.initializeForMobile();
            me.initializeModal(options);
            me.showMain();
        },
        showSecondaryHeroButton: function (options) {

            const me = this;

            function showButton(isKeyGeo) {

                const buttonToShow = (isKeyGeo ? '.x-contact-button.x-demo.hidden' : '.x-signup-button.hidden');

                $('a.x-loading-button').addClass('hidden');
                $(buttonToShow).removeClass('hidden');
            }

            if (options.rivalIqSettings.contactLocationData !== null) {

                // the user's key-geo-ness has already been determined,
                // so use that value and show the appropriate button
                const isKeyGeo = options.rivalIqSettings.contactLocationData.isKeyGeo;
                showButton(isKeyGeo);
            } else {

                // otherwise, determine the user's key-geo-ness and show
                // the appropriate button afterward, or the video button
                // if it times out/produces an error
                $.ajax({
                    type: 'GET',
                    url: '/api/contactLocationData',
                    timeout: 1000,
                    success: function (contactLocationData) {
                        if (!contactLocationData) {
                            showButton(false);
                        } else {
                            me.contactLocationData = contactLocationData;
                            showButton(contactLocationData.isKeyGeo);
                        }
                    },
                    error: function () {
                        // show the fallback button
                        showButton(false);
                    }
                });
            }
        },
        showMain: function () {

            new App.views.Main({
                el: 'body'
            }).render();
        },
        initializeModal: function (options) {

            const me = this;

            me.contactModal = new App.views.ContactModal({
                el: '#contactModal',
                contactLocationData: function () {
                    return me.contactLocationData;
                },
                validEmailAddress: _.get(options, 'rivalIqSettings.validEmailAddress')
            });
        },
        initializeForMobile: function () {

            let viewportMeta = null;

            if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {

                viewportMeta = document.querySelector('meta[name="viewport"]');

                if (viewportMeta) {

                    viewportMeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0';

                    document.body.addEventListener('gesturestart', function () {

                        viewportMeta.content = 'width=device-width, minimum-scale=0.25, maximum-scale=1.6';
                    }, false);
                }
            }
        },
        onContactShowCommand: function (contactType) {

            const me = this;
            const contactModal = me.contactModal;

            contactModal.setType(contactType);

            contactModal.show();
        }
    });

    controllers.addInitializer(function (options) {
        const controller = new Controller(options);
        controller.start(options);
    });

});
